import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

export interface OpcaoSegmentada<T extends string> {
  value: T;
  label: ReactNode;
}

/** Filtro rápido / troca de visão: fundo muted, item ativo branco com sombra. */
export function SegmentedControl<T extends string>({
  value,
  onChange,
  options,
  className,
  "aria-label": ariaLabel,
}: {
  // T vem só de `value` (o estado): assim `onChange={setX}` e opções literais não alargam para string.
  value: T;
  onChange: (v: NoInfer<T>) => void;
  options: OpcaoSegmentada<NoInfer<T>>[];
  className?: string;
  "aria-label"?: string;
}) {
  return (
    <div role="radiogroup" aria-label={ariaLabel} className={cn("inline-flex rounded-lg bg-muted p-[3px]", className)}>
      {options.map((o) => {
        const ativo = o.value === value;
        return (
          <button
            key={o.value}
            type="button"
            role="radio"
            aria-checked={ativo}
            onClick={() => onChange(o.value)}
            className={cn(
              "h-7 whitespace-nowrap rounded-md px-3 text-xs font-medium transition-colors",
              ativo ? "bg-card text-foreground shadow-segmented" : "text-muted-foreground hover:text-foreground",
            )}
          >
            {o.label}
          </button>
        );
      })}
    </div>
  );
}
